export const CHANEL_BRAND_ID = 'CHANE';

export const BrandConfig = {
    productNameOnTwoLines: [CHANEL_BRAND_ID],
    notUnderlined: [CHANEL_BRAND_ID],
};
